<div class="d-flex text-center flex-column">
    <div class="header-container">
        <mat-icon class="material-icon align-self-center mb-3" svgIcon="patient-icon"></mat-icon>
        <span class="t5 bold">{{ patientName}}</span>
        <span class="t4 text-muted">Case no: {{ casenumber }}</span>
    </div>
    <div mat-dialog-content>
        <form [formGroup]="form" class="note-detail-container">
            <label class="form-label">Create Note</label>
            <textarea formControlName="note" class="form-control procedure-name"
                placeholder="Start typing a note here"
                [ngClass]="{ 'is-invalid': controls.note.errors && controls.note.touched }"
                (keyup)="$event.stopPropagation();" maxlength="250" rows="3"
                [(ngModel)]="searchValue" [attr.inputmode]="getInputMode"
                (focus)="onTextareaFocused(true)" (blur)="onTextareaFocused(false)">
                </textarea>
        </form>
    </div>
    <div mat-dialog-actions class="d-flex justify-content-end pt-5">
        <button type="button" class="btn btn-link col-4" (click)="cancelDialog()">Cancel</button>
        <button type="submit" (click)="confirm()" class="btn btn-primary btn-block col-4">Ok</button>
    </div>
    <div *ngIf="isCustomKeyboardVisible()" class="keyboard-container">
        <app-custom-keyboard #customKeyboard [template]="standardTemplate"
            (typedValue)="customKeyboardInput($event)"
            [setValue]="searchValue"></app-custom-keyboard>
    </div>
</div>